import React, {useState, useCallback} from 'react'
import { withRouter } from 'react-router-dom'
import { compose } from 'recompose'

import InputAdornment from '@material-ui/core/InputAdornment'
import TextField from '@material-ui/core/TextField'
import IconButton from '@material-ui/core/IconButton'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import CircularProgress from '@material-ui/core/CircularProgress'

import { withFirebase } from '../../contexts/Firebase'
import { AuthUserContext } from '../../contexts/Session'
import logoOuvidoria from '../../assets/logos/logoApp.svg'
import { ReactComponent as EmailIcon } from '../../assets/Icons/email-login.svg'
import { ReactComponent as PasswordIcon } from '../../assets/Icons/password-login.svg'

import api from '../../services/api'

import './styles.css'

const SignInPage = () => (
    <div id="sign-in-page">
        <SignInForm />
    </div>
)

function SignInFormBase(props){

    const[email, setEmail] = useState('')
    const[password, setPassword] = useState('')
    const[showPassword, setShowPassword] = useState(false)

    const[error, setError] = useState(false)
    const[errorMsg, setErrorMsg] = useState('')
    const[errorPass, setErrorPas] = useState('')
    const[errorPasMsg, setErrorPasMsg] = useState('')
    const[clicked, setClicked] = useState(false)
    const[loginError, setLoginError] = useState(false)

    const handleForgot = useCallback(() => {
        props.history.push('/forgot-password');
    }, [props.history]);

    function handleHome(){
        props.history.push('/')
    }

    function userAlreadyLogged(){
        try {
            props.firebase.auth.currentUser.getIdTokenResult()
                .then((idTokenResult) => {
                    // localStorage.setItem('@Z52InSD4dnfjUDeVSEB0Byy',idTokenResult.token)
                    // localStorage.setItem('VSEB0Byy',idTokenResult.claims.user_id)
                    // props.history.push('/list-profiles')

                    localStorage.setItem('@Z52InSD4dnfjUDeVSEB0Byy',idTokenResult.token)
                    localStorage.setItem('VSEB0Byy',idTokenResult.claims.user_id)
                    console.log(idTokenResult);
                    if(!!idTokenResult.claims.admin){
                        localStorage.setItem('adm', true)
                        props.history.push('/list-profiles')
                        console.log('adm')

                    }else if(!!idTokenResult.claims.ouvidoria){
                        localStorage.setItem('adm', false)
                        props.history.push('/list-profiles')
                        console.log('ouvidoria')

                    }else if(!!!idTokenResult.claims.ouvidoria && !!!idTokenResult.claims.admin){
                        console.log('opaa')
                        props.firebase.doSignOut()
                        setClicked(false)
                        alert('Essa conta não tem acesso ao sistema')

                    }
                })

        } catch (error) {
            setLoginError(true)
        }
    }

    const isDenied = useCallback(() => {
        console.log('login Denied');
        props.history.push('/');
        props.firebase.doSignOut();
        setClicked(false);
        alert('Essa conta não tem acesso ao sistema');
    }, [props.firebase, props.history]);

    const isBlocked = useCallback(async () => {
        await api.get(`/admin/get`, 
        {
            headers: {
                authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}`,   
            }
        }
    ).then( (response) => {
        if (!response.data.user.blocked) {
            localStorage.setItem('adm', false);
            props.history.push('/list-profiles');
            console.log('ouvidoria');
        }else{
            isDenied();
        }
    }).catch((error) =>{
        console.log(error);
        isDenied();
    })
    }, [isDenied, props.history]);

    const onSubmit = async event => {
        setClicked(!clicked)

        props.firebase
        .doSignInWithEmailAndPassword(email, password)
        .then( async(authUser) => {
            setEmail('')
            setPassword('')
            props.firebase.auth.currentUser.getIdTokenResult()
                .then((idTokenResult) => {
                    localStorage.setItem('@Z52InSD4dnfjUDeVSEB0Byy',idTokenResult.token)
                    localStorage.setItem('VSEB0Byy',idTokenResult.claims.user_id)
                    //console.log(idTokenResult.token, 'idTokenResultonLogin');
                    //console.log(authUser.currentUser);
                    if(!!idTokenResult.claims.admin){
                        localStorage.setItem('adm', true)
                        props.history.push('/list-profiles')
                        console.log('adm')

                    }else if(!!idTokenResult.claims.ouvidoria){                        
                        isBlocked();
                    }else if(!!!idTokenResult.claims.ouvidoria && !!!idTokenResult.claims.admin){
                        isDenied();
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
        })
        .catch(error => {
            setClicked(false)
            setErrorMessage(error)
        })
    
        event.preventDefault();
    }

    function setErrorMessage(error){
        if (error.code === 'auth/user-disabled') {
            alert('Sua conta foi bloqueada, solicite o desbloqueio ao administrador')
        }
        if(email===''){
            setErrorMsg('Você deve inserir um usuário')
            setError(true);
            return
        }
        if(password === ''){
            setErrorPasMsg('Você deve inserir uma senha')
            setErrorPas(true)
            return
        }
        else{
            if(error.code === 'auth/invalid-email'){
                setErrorMsg('Email inválido')
                setError(true);
                return
            }
            if(error.code === 'auth/user-not-found'){
                setErrorMsg('Usuário não encontrado')
                setError(true);
                return
            }
            if(error.code === "auth/wrong-password"){
                setErrorPasMsg('Senha Inválida')
                setErrorPas(true)
                return
            }
        }

    }

    return (
        <AuthUserContext.Consumer>
        {
        authUser =>
            !authUser || loginError ? // !authUser || loginError? 
                <div className='container-background'>
                    <div className='container-login'>
                        <img src={logoOuvidoria} alt="ouvidoria" className='login-image'/>
                        
                        <form onSubmit={onSubmit}>

                            <div className='login-inputs'>
                                <TextField
                                    className='input-login' 
                                    id="input-email"
                                    label={error ? errorMsg :"Email"} 
                                    error={error}
                                    value={email}
                                    fullWidth
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <EmailIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                    onChange={event => {
                                        setEmail(event.target.value);
                                        setError(false)
                                    }} 
                                /> <br/> <br/>

                                <TextField
                                    className='input-login' 
                                    id="input-password"
                                    label={errorPass ? errorPasMsg: 'Senha'}
                                    type={showPassword ? 'text' : 'password'}
                                    value={password}
                                    error={errorPass}
                                    fullWidth
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <PasswordIcon />
                                            </InputAdornment>
                                        ),
                                        endAdornment:(
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={() => setShowPassword(!showPassword)}
                                                    onMouseDown={event => event.preventDefault()}
                                                    edge="end"
                                                >
                                                {showPassword ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    onChange={event => {
                                        setPassword(event.target.value)
                                        setErrorPas(false)
                                    }}
                                /> <br/>
                            </div>
                            <button id ='submit-button'className='modal-header-button' disabled={clicked}>
                                {clicked?
                                    <CircularProgress color='secondary' size={15} />:
                                    <p className='modal-header-button-text'>ENTRAR</p>
                                }
                            </button>
                            <p className='text-forgget' onClick={handleForgot}>Recuperar a senha</p>
                            <p className='text-login' onClick={handleHome}>Voltar ao Mapa</p>
                            <br/><br/>
                        </form>

                    </div>
                </div>
                :userAlreadyLogged()

        }
        </AuthUserContext.Consumer>
    )
}

const SignInForm = compose(
    withRouter,
    withFirebase,
)(SignInFormBase);

export default SignInPage;

export { SignInForm };